import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { css } from "emotion";
import { boxInfoRegisteredStyle } from "./style";
import CardCompanies from "../CardCompanies/CardCompanies";
import TooltipOffers from "../TooltipOffers/TooltipOffers";
import { NavLink } from "react-router-dom";
import { useNewOffer } from "../../../js/context/new-offer";
import { floatFormat, formatCurrency, intFormat } from "../utils/formats";
import { ROUTE_ACCOUNT_DETAILS } from "../../../js/shared/constants";
import { MINIMAL_MILES_ADVANCED_AVERAGE, AIRLINE_PROGRAMS } from "../../../js/shared/enums";
import { getStartAverage, formatPhone } from "../../../js/shared/utils";
import Button from "../../button/button";
import ModalLatamPhone from "../ModalPhoneLatam/ModalLatamPhone";
import { setFidelityPhoneByFidelityId } from "../../../js/shared/requests-api";
import { refreshOffers } from "../../../js/actions";

const BoxInfoRegistered = ({ refreshOffers, typePhoneLatam }) => {
	const [totalExpectedGain, setTotalExpectedGain] = useState(0);
	const [showModalPhone, setShowModalPhone] = useState(false);
	const {
		currentProgram,
		offerData,
		rankingData,
		bankData,
		editOffer,
		creditCardData,
		banks,
		smilesDiamond,
		bonusData: { data: bonusData },
		participantData,
		loyaltyData,
		phoneMultiplus,
		setLoyaltyData
	} = useNewOffer();

	const [showCreditCard] = useState(
		currentProgram &&
		currentProgram.international === "1" &&
		(currentProgram.id == 25 ||
			currentProgram.id == 11 ||
			currentProgram.id == 10 ||
			currentProgram.id == 14)
	);

	const phoneMMSuggestion = phoneMultiplus;
	const { price, quant, averageMiles, reductions } = offerData.data;
	const { phone, isMaxPhone, id } = loyaltyData.data;
	const { countAllowedSales } = rankingData.data;
	const { agency, cpfcnpj, account, bankId, type } = bankData.data;
	const bankName = banks.data.find(val => val.idBank == bankId);

	const isQuickSale = editOffer && editOffer.quickSale;
	const forwardPayment = editOffer.forwardPayment;

	const bonusValid =
		!isQuickSale &&
		!forwardPayment &&
		bonusData.enabled &&
		quant >= bonusData.minMiles &&
		countAllowedSales >= bonusData.minCPFs &&
		averageMiles >=
		getStartAverage(quant, countAllowedSales, bonusData.minAverage, bonusData.maxAverage) &&
		averageMiles <= bonusData.maxAverage;

	const getAdvancedConfigMinMiles = () =>
		bonusData && bonusData.enabled ? bonusData.minMiles : MINIMAL_MILES_ADVANCED_AVERAGE;

	let maxSales = parseInt(quant / averageMiles);
	if (maxSales > countAllowedSales) {
		maxSales = countAllowedSales;
	}

	const showReduction = () => {
		return quant >= 60000 && currentProgram.id === AIRLINE_PROGRAMS.SMILES.id && smilesDiamond && !!reductions;
	};

	const isLatam = () => {
		return currentProgram.id === 3 || currentProgram.id === 1;
	};

	const tabEditHandle = tab => {
		if (tab == "bank") {
			localStorage.setItem("editBankSelected", "1");
		} else if (tab == "card") {
			localStorage.setItem("editCardSelected", "1");
		}
	};

	useEffect(() => {
		setTotalExpectedGain((parseInt(quant) / 1000) * floatFormat(price.toString()));
	}, []);

	const onChangePhone = phone => {
		let phoneMax = 0;
		setFidelityPhoneByFidelityId(id || 3, phone).then(() => {
			if (phoneMMSuggestion === phone) {
				phoneMax = 1;
			} else {
				phoneMax = 0;
			}
			setLoyaltyData({
				...loyaltyData,
				data: { ...loyaltyData.data, isMaxPhone: phoneMax, phone: phone }
			});

			refreshOffers();

			setShowModalPhone(false);
		});
	};

	const isWrongLatamPhone = isLatam() && (isMaxPhone === 0 || isMaxPhone === -1);

	return (
		<div
			className={css`
				${boxInfoRegisteredStyle};
			`}
		>
			<div className="resume-row d-flex">
				<p className="title">Dados da oferta</p>
			</div>
			<div className="resume-row d-flex">
				<div className="area-card-company">
					<CardCompanies
						programFidelity={currentProgram.fidelityName}
						company={currentProgram.acronym}
						height="112px"
						width="112px"
						onClick={() => { }}
					/>
				</div>
				<div className="area-infos">
					<div className="area-total-expected-gain">
						<div className="mgr-64">
							<p className="title">{`${forwardPayment ? "Você vai receber" : "Você pode receber até"
								}`}</p>
							<div className="box-price">
								<p className="box-price--currency">R$ {formatCurrency(totalExpectedGain)}</p>
								<div className="box-price--tooltip">
									<TooltipOffers
										position="bottom-end"
										content={
											<p style={{ fontWeight: "bold", textAlign: "left" }}>
												Valor total a receber caso venda todas as milhas.
											</p>
										}
									/>
								</div>
							</div>
						</div>
						{bonusValid && (
							<div className="mgr-64">
								<p>Bônus</p>
								<p className="values">
									<strong>+R$ {formatCurrency(maxSales * bonusData.value)}</strong>
								</p>
							</div>
						)}
					</div>
					<div className="area-offer-data">
						<div className="mgr-64">
							<p>Valor a cada 1.000 milhas</p>
							<p className="values">R$ {formatCurrency(price)}</p>
						</div>

						<div className="mgr-64">
							<p>Quantidade de milhas</p>
							<p className="values">{intFormat(quant)} milhas</p>
						</div>

						{(currentProgram.international != 1 || currentProgram.id === AIRLINE_PROGRAMS.TAP.id) && quant >= getAdvancedConfigMinMiles() && (
							<div className="mgr-64">
								<p>Média por passageiro</p>
								<div className="d-flex">
									<p className="values">{intFormat(Math.floor(averageMiles / 500) * 500)} milhas</p>
									{averageMiles % 500 > 0 && (
										<div className="box-price--tooltip">
											<TooltipOffers
												position="bottom-end"
												content={
													<p style={{ fontWeight: "bold", textAlign: "left" }}>
														Sua média foi arredondada para multiplos de 500.
													</p>
												}
											/>
										</div>
									)}
								</div>
							</div>
						)}

						{showReduction() && (
							<div className="mgr-64">
								<p>Reduções de milhas</p>
								<p className="values">
									{reductions == 1 ? `${reductions} passagem` : `${reductions} passagens`}{" "}
								</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{isLatam() && typePhoneLatam === 0 && (
				<>
					<div className="phoneLatam-row">
						<div className="bank-details">
							<p className="title">Telefone LATAM Pass</p>
							<p className={`values ${isWrongLatamPhone ? "wrongValue" : ""}`}>
								{formatPhone(phone)}
							</p>
						</div>
						{isWrongLatamPhone && (
							<div className="col-xs-8">
								<Button
									onClick={() => setShowModalPhone(true)}
									className={"btn button-fix-number"}
									data-action="update-latam-phone-show-modal"
								>
									Corrigir número
								</Button>
							</div>
						)}
					</div>
				</>
			)}

			{!participantData.hasManagementActive && (
				<>
					<div className="bank-row d-flex">
						<div className="resume-row d-flex">
							<p className="title">Dados da Bancários </p>
							<div className="bank-details--edit">
								<NavLink to={`${ROUTE_ACCOUNT_DETAILS}`}>
									<div
										onClick={() => tabEditHandle("bank")}
										className="bank-details--edit--link"
										data-action="finished-offer-edit-bank"
									>
										<strong>Editar</strong>
									</div>
								</NavLink>
							</div>
						</div>
						<div className="d-flex">
							<div className="bank-details">
								<p>Banco</p>
								<span className="values">{bankName.name}</span>
							</div>
							<div className="bank-details">
								<p>Agência</p>
								<span className="values">{agency}</span>
							</div>
							<div className="bank-details">
								<p>Conta corrente</p>
								<span className="values">{account}</span>
							</div>
							<div className="bank-details">
								<p>CPF/CNPJ</p>
								<span className="values">
									{cpfcnpj.length <= 14
										? cpfcnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4")
										: cpfcnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5")}
								</span>
							</div>
						</div>
					</div>
				</>
			)}

			{showCreditCard && (
				<div className="cc-row d-flex">
					<div className="resume-row d-flex">
						<p className="title">Dados do Cartão de Crédito </p>
						<div className="cc-details--edit">
							<NavLink to={`${ROUTE_ACCOUNT_DETAILS}`}>
								<div
									onClick={() => tabEditHandle("card")}
									className="cc-details--edit--link"
									data-action="finished-offer-edit-credit-card"
								>
									<strong>Editar</strong>
								</div>
							</NavLink>
						</div>
					</div>
					<div className="d-flex">
						<div className="cc-details">
							<p>Número</p>
							<span className="values">
								**** **** ****{" "}
								{(creditCardData.data.cardNumber &&
									creditCardData.data.cardNumber.substring(0, 4)) ||
									creditCardData.data.number}
							</span>
						</div>
						<div className="cc-details">
							<p>Nome</p>
							<span className="values">
								{creditCardData.data.holderName || creditCardData.data.name}
							</span>
						</div>
						<div className="cc-details">
							<p>CPF</p>
							<span className="values">
								{creditCardData.data.cardCpf || creditCardData.data.cpf}
							</span>
						</div>
					</div>
				</div>
			)}
			<ModalLatamPhone
				show={showModalPhone}
				close={() => setShowModalPhone(false)}
				confirm={onChangePhone}
				phoneSugestion={phoneMMSuggestion}
				phone={phone}
				updateLatamPhone
			/>
		</div>
	);
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => {
	return {
		refreshOffers: () => dispatch(refreshOffers())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(BoxInfoRegistered);
